import React, { Component } from "react";
import { Helmet } from "react-helmet";
import auth from "../../../services/authService";
import EntityContext from "../../../context/entityContext";

import TfCustomerTransactionList from "./tfTransactions/invoiceList/customerTransactionList";
import CustomerTransactionList from "./scTransactions/invoiceList/customerTransactionList";
import InvoicesList from "./ifTransactions/invoiceList";

class PurchaseInvoices extends Component {

  static contextType = EntityContext;
  constructor(props) {
    super(props);
  }

  state = {
    selectedTab: this.props.location.state ? this.props.location.state : null,
    ajaxRequest: false,
    selectedRows: [],
    categories: [],
    open: false,
    openCustomer: false,
    approvebuttonClass: "btn btn-primary  hidden",
    declinebuttonClass: "btn btn-danger  hidden",
    bulkapprove: false,
    bulkreject: false,
    selected: {},
    roleType: "Purchase",
    tabs: [],
    checkbox: true,
  };

  render() {

    const { constants } = auth.getCurrentUser();

    return (
      <>
        <Helmet>
          <title>Invoice List| {global.config.title}</title>
        </Helmet>
        {this.context && (
          <>
              {(this.context.selProduct == "ALL" || this.context.selProduct == constants.PRODUCTS.SUPPLYCHAIN ) && ( <CustomerTransactionList selectedTab={ this.state.selectedTab} productType = {this.context.selProduct}></CustomerTransactionList> )}
              {this.context.selProduct == constants.PRODUCTS.TRADEFINANCE && <TfCustomerTransactionList selectedTab={ this.state.selectedTab} productType = {this.context.selProduct} />}
              {this.context.selProduct == constants.PRODUCTS.INVOICE && ( <InvoicesList status={this.props.location.query.status} type={this.props.location.query.type}/>)}
          </>
        )}
      </>
    );
  }
}
export default PurchaseInvoices;